import { DataTableCell, Table, TableBody, TableHeader } from "@david.kucsai/react-pdf-table";
import { arrayOf, func, shape } from "prop-types";
import React from "react";
import { formatDate } from "utils/dateUtils";

import { cellStyle } from "./style";

function VisitReports({ data, cell: Cell }) {
  return (
    <Table data={data}>
      <TableHeader>
        <Cell>Data</Cell>
        <Cell>Intervenção / Doença / Praga / Infestante detectada acima do NEA</Cell>
        <Cell>Substância Ativa Recomendada</Cell>
      </TableHeader>

      <TableBody>
        <DataTableCell style={cellStyle} getContent={({ date }) => formatDate(date)} />
        <DataTableCell style={cellStyle} getContent={({ intervention }) => intervention} />
        <DataTableCell style={cellStyle} getContent={({ recommendedActiveSubstance }) => recommendedActiveSubstance} />
      </TableBody>
    </Table>
  );
}

VisitReports.propTypes = {
  data: arrayOf(shape({})),
  cell: func.isRequired,
};

VisitReports.defaultProps = {
  data: [],
};

export default VisitReports;
